import queryString from 'query-string';
import { isEmpty } from 'lodash/lang';
import { omit } from 'lodash/object';

export function isStartsWithHttp(redirect = '') {
    return redirect.startsWith('http');
}

export function isStartsWithSlashContainer(redirect = '') {
    return redirect.startsWith('/container');
}

export function getAppCodeFromRedirect(redirect = '') {
    if (!isStartsWithSlashContainer(redirect)) {
        return '';
    } else {
        const array = redirect.split('/');
        if (array.length >= 3) {
            const appCode = array[2];
            if (appCode) {
                return appCode;
            } else {
                return '';
            }
        } else {
            return '';
        }
    }
}

// 是否是信息化 sso 地址
export function isIMSUrl(redirect = '') {
    return redirect.startsWith('http') && redirect.includes('ims') && redirect.includes('xinchao.com');
}

// 是否是 sf 地址
export function isSFUrl(redirect = '') {
    return redirect.includes('sf');
}

// 是否是 oa 地址
export function isOAUrl(redirect = '') {
    return redirect.includes('oa.');
}

// 对于 redirect 地址是完整 url 情况的处理
export function genCommonRedirectURL(redirect = '', accessToken = '', preAuthCode = '') {
    // 有时会传 null
    let _preAuthCode = preAuthCode;
    let _redirect = redirect;

    if (!_preAuthCode) {
        _preAuthCode = '';
    }
    try {
        _redirect = decodeURIComponent(_redirect);
    } catch (e) {
        // @SEE https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Errors/Malformed_URI
        console.error(e);
        throw new Error('解析 redirect 链接失败');
    }

    const urlSplitBySharp = _redirect.split('#');
    const urlWithoutHash = urlSplitBySharp[0];
    if (!urlWithoutHash) {
        console.error('跳转地址为空');
        throw new Error('跳转地址为空');
    }

    const urlObject = queryString.parseUrl(urlWithoutHash);
    let redirectUrl;
    if (isEmpty(urlObject.query)) {
        // @TODO 后期不再直接带 token 在 url 中
        // @TODO 在 preAuthCode 为空的时候，不拼接在 url 中???
        redirectUrl = `${urlObject.url}?token=${accessToken}&preAuthCode=${_preAuthCode}`;
    } else {
        let paramsWithToken = {
            ...urlObject.query,
            token: accessToken,
            preAuthCode: _preAuthCode,
        };
        let search = queryString.stringify(paramsWithToken);
        redirectUrl = `${urlObject.url}?${search}`;
    }

    const hash = urlSplitBySharp[1];
    if (!isEmpty(hash)) {
        redirectUrl = `${redirectUrl}#${hash}`;
    }

    return redirectUrl;
}

// 获取 ims(信息化 sso 登录平台) 登录的跳转链接
// 这里对于 hash 的处理会有歧义
// 如: https://ims-dev.xinchao.com/sso/web/index.html?service=https://ims-dev.xinchao.com/portal/pc/index.html#/login
// ims 这里 service 应该做两次 encode
// 如: https%3A%2F%2Fims-dev.xinchao.com%2Fsso%2Fweb%2Findex.html%3Fservice%3Dhttps%253A%252F%252Fims-dev. \
//  xinchao.com%252Fportal%252Fpc%252Findex.html%2523%252Flogin
// @XXX 对于带有 hash 的参数值，hash 会丢失
export function genImsJumpUrl(redirect = '', ticket = '', accessToken = '') {
    if (!redirect) {
        throw new Error('redirect is empty');
    }
    if (!ticket) {
        throw new Error('ticket is empty');
    }
    if (!accessToken) {
        throw new Error('accessToken is empty');
    }
    const parsedRedirectUrl = queryString.parseUrl(redirect);
    const query = {
        ...parsedRedirectUrl.query,
        // 这里参数名由第三方系统定义
        // eslint-disable-next-line camelcase
        puma_code: ticket,
        // eslint-disable-next-line camelcase
        puma_token: accessToken,
    };
    return queryString.stringifyUrl({
        url: parsedRedirectUrl.url,
        query,
    });
}

// 过滤 url 中出现的 query 参数
export function omitSearchParamsFromUrl(url = '', omitParams = []) {
    const originUrlObj = queryString.parseUrl(
        url,
        {
            decode: false,
            parseFragmentIdentifier: true
        }
    );

    const query = omit(originUrlObj.query, omitParams);
    return queryString.stringifyUrl({
        ...originUrlObj,
        query,
    },{
        encode: false,
    });
}

export function cleanUrl() {
    try {
        const url = omitSearchParamsFromUrl(window.location.href, ['code', 'token', 'from', 'state']);
        window.history.replaceState(null, '', url);
    } catch(e) {
        console.error(e);
    }
}

//  判读 a 中任何一个元素是否在 b 中出现过
export function isAnyoneInThere(a = [], b = []) {
    if (a.length === 0) {
        return false;
    } else if (b.length === 0) {
        return false;
    }

    // 断言 a, b 都不为空

    let res = false;
    a.forEach(item => {
        if (b.indexOf(item) !== -1) {
            res = true;
            return false;
        }
    });
    return res;
}
